import { ScanSearch } from 'lucide-react';
import { FC } from 'react';

import { useAppSelector } from '@shared/hooks/redux';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';

import cls from './HoverMask.module.scss';

type HoverMaskProps = {
  mobileHidden?: boolean;
};

export const HoverMask: FC<HoverMaskProps> = ({ mobileHidden }) => {
  const viewPort = useAppSelector(getViewPort);

  if (mobileHidden && viewPort === 'mobile') {
    return null;
  }

  return (
    <div
      data-testid={'scan-search-icon'}
      className={cls.hoverMask}
    >
      <ScanSearch
        size={66}
        color={'#ffffff'}
      />
    </div>
  );
};
